import React from "react";
import { useGamesForConvention, useMyGames } from "@seabrookstudios/pitch2table";
import { FilterableGamesList } from "../games/FilterableGamesList";
import { EventFromRouteGameListItem } from "../games/ListItem";
import { FullScreenDialog } from "../core/FullScreenDialog";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";

/**
 * @param {object} props
 * @param {import("@seabrookstudios/pitch2table-core").ConventionId} props.conventionId
 * @param {import("@seabrookstudios/pitch2table-core").PublisherId|undefined} props.linkedPublisherId
 * @param {boolean} props.open
 * @param {() => void} props.onClose
 */
export const AddGamesToConventionDialog = ({ conventionId, linkedPublisherId, open, onClose }) => {
  const { data: myGames = [], isLoading } = useMyGames();
  const { data: conventionGames = [] } = useGamesForConvention(conventionId);

  const isGameLinked = (gameId) => conventionGames.some((game) => game.id === gameId);

  return (
    <FullScreenDialog id="add-games-to-convention" title="Add Games to Convention" open={open} onClose={onClose}>
      {isLoading ? (
        <Box sx={{ display: "flex", justifyContent: "center", p: 4 }}>
          <CircularProgress />
        </Box>
      ) : (
        <FilterableGamesList
          games={myGames}
          renderGame={(game) => (
            <EventFromRouteGameListItem
              game={game}
              isLinked={isGameLinked(game.id)}
              conventionId={conventionId}
              linkedPublisherId={linkedPublisherId}
            />
          )}
        />
      )}
    </FullScreenDialog>
  );
};
